import { render, staticRenderFns } from "./UserBubble.vue?vue&type=template&id=900df69e&scoped=true"
import script from "./UserBubble.vue?vue&type=script&lang=js"
export * from "./UserBubble.vue?vue&type=script&lang=js"
import style0 from "./UserBubble.vue?vue&type=style&index=0&id=900df69e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "900df69e",
  null
  
)

export default component.exports